import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';

export function SubCtaLink({
  to,
  children,
  trackingId,
  trackingValue,
  containerClassName = 'ms-0_5 mb-1',
  linkTextClasses,
  showArrow = true,
  ...otherProps
}) {
  return (
    <div className={containerClassName}>
      <Link
        to={to}
        className="text-primary-darker size-16"
        data-tracking-id={trackingId}
        data-tracking-value={trackingValue}
        {...otherProps}
      >
        <span className={linkTextClasses}>{children}</span>
        {showArrow && <i className="icon-arrow-right4 size-10 ps-0_25" aria-hidden />}
      </Link>
    </div>
  );
}

SubCtaLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  trackingId: PropTypes.string,
  trackingValue: PropTypes.string,
  containerClassName: PropTypes.string,
  linkTextClasses: PropTypes.string,
  showArrow: PropTypes.bool,
};
